<template>
  <button
    type="button"
    class="btn btn-sm btn-outline-secondary tw:inline-flex tw:items-center tw:gap-1.5"
  >
    <Pencil class="tw:size-3.5" />
    {{ $t("Change") }}
  </button>
</template>

<script setup>
import { Pencil } from "@lucide/vue";

/**
 * The edit control of a booking step. One labelled control everywhere rather than a bare icon on
 * one screen and a pill on the other: the two screens show the same steps and should offer the
 * same affordance. Clicks fall through to the parent.
 */
</script>
